export default function roomStickerEventListener(room) {
  return store => {
    room.addEventListeners({
        room_sticker_set: e => {
          store.commit('sticker/SET_ROOM_USER_STICKER', e.data);
        },
        room_sticker_set_all: e => {
          store.commit('sticker/SET_ALL_ROOM_USER_STICKER', e.data);
        },
    });
  }
}
